import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Divider,
  CircularProgress,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

export default function DeleteConfirmModal({ open, row, onClose, onConfirm, loading }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: 2 } }}>
      <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", pb: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <WarningAmberIcon sx={{ color: "#d32f2f", fontSize: 20 }} />
          <Typography fontWeight={600} fontSize="1rem">Delete redirect</Typography>
        </Box>
        <IconButton size="small" onClick={onClose}><CloseIcon fontSize="small" /></IconButton>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ pt: 2 }}>
        <Typography fontSize={14} mb={1.5}>
          Are you sure you want to delete this redirect? This cannot be undone.
        </Typography>
        {row && (
          <Box sx={{ p: 1.5, backgroundColor: "#fff8f8", border: "1px solid #ffcdd2", borderRadius: 1.5 }}>
            <Typography fontSize={13} fontFamily="monospace" color="#c62828">
              {row.from_path}
            </Typography>
            <Typography fontSize={12} color="text.secondary" mt={0.3}>
              → {row.to_url}
            </Typography>
          </Box>
        )}
      </DialogContent>
      <Divider />
      <DialogActions sx={{ px: 2.5, py: 1.5, gap: 1 }}>
        <Button onClick={onClose} variant="outlined" sx={{ textTransform: "none", borderColor: "#bdbdbd", color: "#424242" }}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          disabled={loading}
          sx={{ textTransform: "none", minWidth: 100 }}
        >
          {loading ? <CircularProgress size={18} color="inherit" /> : "Delete"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}